import {
  MenuItem,
  MenuList,
  MenuListProps as ChakraMenuListProps,
} from '@chakra-ui/react'
import React, { Children } from 'react'
import { v4 as uuidv4 } from 'uuid'

interface MenuListProps extends ChakraMenuListProps {
  children: React.ReactElement[] | React.ReactElement
}

const DropdownMenuItems = (props: MenuListProps) => {
  const { children = [], ...otherProps } = props

  const childrenArr = Children.toArray(children)

  return (
    <MenuList
      bg="white"
      position="absolute"
      top="-9px"
      left="-1px"
      borderRadius="1px"
      borderColor="gray.500"
      {...otherProps}
    >
      {childrenArr.length > 1
        ? childrenArr.map(child => <MenuItem key={uuidv4()}>{child}</MenuItem>)
        : children}
    </MenuList>
  )
}

export default DropdownMenuItems
